import script from "./PropertyLogsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PropertyLogsCard.vue?vue&type=script&setup=true&lang=js"

import "./PropertyLogsCard.vue?vue&type=style&index=0&id=f0909968&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0909968"]])

export default __exports__